import { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';

import { useIsSmartContractsEnabled } from ':cloud/hooks/featureFlags/useIsSmartContractsEnabled';
import { Indexers } from ':cloud/pages/Indexers';
import { SmartContracts } from ':cloud/pages/SmartContracts';
import { AppRoute } from ':cloud/utils/routes';
import { RoutedTopNavTabs } from ':cloud/widgets/sharedcomponents/RoutedTopNavTabs';

export function OnChainData() {
  const isSmartContractsEnabled = useIsSmartContractsEnabled();

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        id: 'overview',
        label: 'Overview',
        route: AppRoute.Products.OnchainData,
      },
    ];

    if (isSmartContractsEnabled) {
      baseTabs.push({
        id: 'smartContracts',
        label: 'Smart Contracts',
        route: AppRoute.Products.OnchainDataSmartContracts,
      });
    }

    return baseTabs;
  }, [isSmartContractsEnabled]);

  return (
    <VStack width="100%">
      {tabs.length > 1 && <RoutedTopNavTabs tabs={tabs} />}
      <Switch>
        <Route exact path={AppRoute.Products.OnchainData}>
          <Indexers />
        </Route>
        {isSmartContractsEnabled && (
          <Route exact path={AppRoute.Products.OnchainDataSmartContracts}>
            <SmartContracts />
          </Route>
        )}
        <Redirect to={AppRoute.Products.OnchainData} />
      </Switch>
    </VStack>
  );
}
